export const config = {
  cqPartnersUrl: process.env.REACT_APP_CQ_PARTNERS_URL,
  cheqApiUrl: process.env.REACT_APP_CHEQ_API_URL,
  googleClientID: process.env.REACT_APP_GOOGLE_SSO_CLIENT_ID,
};
